module.exports = __webpack_public_path__ + "static/media/back_btn.c452ac7f.svg";